module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-list', {
    staticClass: "item-detail",
    attrs: {
      "modifier": "noborder"
    }
  }, [_c('item-outline', {
    attrs: {
      "thing": _vm.destination
    }
  }), _vm._v(" "), _c('v-ons-list-item', {
    attrs: {
      "modifier": "longdivider"
    }
  }, [_c('div', {
    staticClass: "left list-label"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/icon-memo.svg")
    }
  }), _vm._v("メモ\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_vm._v("\n      " + _vm._s(_vm.destination.item.memo) + "\n    ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05adbcf6","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/destination/state/item.vue
// module id = 607
// module chunks = 0